import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { Picksheet } from '~/domains/contest/domains/services/interfaces/picksheet.interface';

function getIsContestConfidenceScoreEnabled(
  contest: FullContest | Contest,
  picksheet?: Picksheet
): boolean {
  const isContestOn = !!contest.settings.confidenceScoring;
  if (picksheet) {
    return !!picksheet.confidence && isContestOn;
  }
  return isContestOn;
}

export default getIsContestConfidenceScoreEnabled;
